import { Badge } from '@foam/buoy/src/components/Badge/Badge';

interface AddedBadgeProps {
  isVisible: boolean;
}

export const AddedBadge = ({ isVisible }: AddedBadgeProps) => {
  if (!isVisible) return null;

  return (
    <div className="absolute right-1 top-1">
      <Badge
        variant="secondary"
        size="sm"
        className="px-2 text-root-size-body-md"
      >
        Added
      </Badge>
    </div>
  );
};
